// extracted by mini-css-extract-plugin
export default {"wrapper":"Dessert_wrapper__cotTH","container":"Dessert_container__lGb4p","list":"Dessert_list__RHCj2","products":"Dessert_products__tAAf9"};